import { render, staticRenderFns } from "./OrderCheckDialog.vue?vue&type=template&id=535e3a1d&scoped=true&"
import script from "./OrderCheckDialog.vue?vue&type=script&lang=js&"
export * from "./OrderCheckDialog.vue?vue&type=script&lang=js&"
import style0 from "./OrderCheckDialog.vue?vue&type=style&index=0&id=535e3a1d&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "535e3a1d",
  null
  
)

export default component.exports